import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Selo de status. Fundo bem claro + texto saturado + anel de 1px: legível numa
 * tabela densa sem virar mancha de cor.
 */
const badgeVariants = cva(
  cn(
    "inline-flex items-center gap-1.5 rounded-md px-2 py-0.5",
    "text-[10px] font-bold uppercase tracking-[0.08em] leading-5",
    "ring-1 ring-inset transition-colors",
  ),
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground ring-transparent",
        outline: "bg-transparent text-foreground ring-border",
        ok: "bg-emerald-50 text-emerald-800 ring-emerald-600/20",
        atencao: "bg-amber-50 text-amber-800 ring-amber-600/25",
        erro: "bg-red-50 text-red-800 ring-red-600/20",
        neutro: "bg-muted text-muted-foreground ring-border",
        info: "bg-cyan-50 text-cyan-800 ring-cyan-600/20",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export function Badge({
  className,
  variant,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
